import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subscription, Subject, lastValueFrom } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { AppData } from 'src/app/helpers/app-data';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";

declare var fabric: any;

@Component({
  selector: 'app-acceso',
  templateUrl: './acceso.component.html',
  styleUrl: './acceso.component.css',
})
export class AccesoComponent implements OnInit, OnDestroy {
  @Input() cancelButton: boolean = false;
  @Output() usuariosExcluidosChange = new EventEmitter<any[]>();

  dialogComponentGuardarPermisos: any;
  dialogComponentPermisosGuardados: any;
  permitidos = AppData.PERMISOSMENU;

  private currentUserIdSubscription: Subscription;
  private currentMenuIdSubscription: Subscription;
  private currentIsOptionMenuSubscription: Subscription;

  isOptionMenu = false;

  constructor(
    private baseService: BaseServiceService,
    private renderer: Renderer2,
    private http: HttpClient,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.permisosProcesoObj = new SetPermisos();
  }
  @Input() reloadTables: boolean = false;
  @Input() ActivityId?: string;

  idReceived: number | null = null;
  idReceivedMenu: number | null = null;
  dialogComponentModalPermisosUsuario: any;
  dialogComponentModalPermisosRol: any;
  dialogComponentModalPermisosGrupo: any;
  dialogComponentRemovePermision: any;
  botonProcesando = false;
  serviceUrl: string = 'Usuario/GetDataTableUsuario';
  dtTriggerUsuario: Subject<any> = new Subject<any>();
  dtTriggerRol: Subject<any> = new Subject<any>();
  dtTriggerGrupo: Subject<any> = new Subject<any>();
  usuariosPermitidos = [];
  rolesPermitidos = [];
  gruposPermitidos = [];
  paramIdProceso;
  paramToken;
  permisosProcesoObj: SetPermisos;
  headers;
  columnasUsuario = [
    { title: "Usuario", data: "Email" }
  ];
  usuariosGrid = [];

  columnasRol = [
    { title: "Rol", data: "NombreRol" }
  ];
  rolesGrid = [];
  usuariosExcluidos: any;
  rolesExcluidos: any;
  GruposExcluidos: any;
  columnasGrupo = [
    { title: "Grupo", data: "NombreGrupo" }
  ];
  gruposGrid = [];

  dtTableId: string;

  dtOptionsUsuarios: DataTables.Settings = {
    pagingType: 'full_numbers',
    pageLength: 5,
    serverSide: false,
    processing: true,
    searching: true,
    ordering: true,
    data: this.usuariosGrid,
    columns: this.columnasUsuario,
    language: {
      url: '../../../assets/es-ES.json',
    },
    lengthMenu: [5],
  };

  dtOptionsRoles: DataTables.Settings = {
    pagingType: 'full_numbers',
    pageLength: 5,
    serverSide: false,
    processing: true,
    searching: true,
    ordering: true,
    data: this.rolesGrid,
    columns: this.columnasRol,
    language: {
      url: '../../../assets/es-ES.json',
    },
    lengthMenu: [5],
  };
  dtOptionsGrupos: DataTables.Settings = {
    pagingType: 'full_numbers',
    pageLength: 5,
    serverSide: false,
    processing: true,
    searching: true,
    ordering: true,
    data: this.gruposGrid,
    columns: this.columnasGrupo,
    language: {
      url: '../../../assets/es-ES.json',
    },
    lengthMenu: [5], // Ocultar la opción de cambiar la cantidad de registros a mostrar
  };

  dtOptionsPermisosUsuario: DataTables.Settings = {};

  dtOptButtonsPermisosUsuarios: any = [
    {
      'button-id': 'btnUnCheck',
      'button-icon': 'ms-Icon--Checkbox',
      'conditional-data': [{ key: 'field', value: 'Email' }],
    },
    {
      'button-id': 'btnCheck',
      'button-icon': 'ms-Icon--CheckboxComposite',
      'button-hide': true,
      'conditional-data': [{ key: 'field', value: 'Email' }],
    },
  ];
  dtInstancePermisosUsuarios: DataTables.Api;
  getUsuarios = ['Usuario', 'GetDataTableUsuarioActivoFiltrado'];

  dtOptionsPermisosRol: DataTables.Settings = {};
  dtOptButtonsPermisosRol: any = [
    {
      'button-id': 'btnUnCheck',
      'button-icon': 'ms-Icon--Checkbox',
      'conditional-data': [{ key: 'field', value: 'NombreRol' }],
    },
    {
      'button-id': 'btnCheck',
      'button-icon': 'ms-Icon--CheckboxComposite',
      'button-hide': true,
      'conditional-data': [{ key: 'field', value: 'NombreRol' }],
    },
  ];
  dtInstancePermisosRol: DataTables.Api;
  getRoles = ['RolUsuario', 'GetDataTableRolUsuarioActivoFiltrado'];

  dtOptionsPermisosGrupo: DataTables.Settings = {};
  dtOptButtonsPermisosGrupo: any = [
    {
      'button-id': 'btnUnCheck',
      'button-icon': 'ms-Icon--Checkbox',
      'conditional-data': [{ key: 'field', value: 'NombreGrupo' }],
    },
    {
      'button-id': 'btnCheck',
      'button-icon': 'ms-Icon--CheckboxComposite',
      'button-hide': true,
      'conditional-data': [{ key: 'field', value: 'NombreGrupo' }],
    },
  ];
  dtInstancePermisosGrupo: DataTables.Api;
  getGrupos = ['GrupoUsuario', 'GetDataTableGrupoUsuarioActivoFiltrado'];

  groupDelete: any;
  idDelete: any;

  reloadPermissions() {
    $('#datatableUsuarios').DataTable().destroy();

    this.dtOptionsUsuarios.data = this.usuariosGrid;
    this.dtOptionsUsuarios.columns = [
      ...this.columnasUsuario,
      {
        title: 'Eliminar',
        data: 'Id',
        orderable: false,
        render: (data: any, type: any, full: any) => {
          // Inicializar botones existentes
          let buttons = `
      <button class="ms-CommandButton-button" data-group="usuario" data-id="${full.Id}" data-field="${full.Email}" id="btnDelete">
      <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
      </button>`;

          return buttons;
        },
      },
    ];

    this.dtTriggerUsuario.next(this.dtOptionsUsuarios);

    $('#datatableRoles').DataTable().destroy();

    this.dtOptionsRoles.data = this.rolesGrid;
    this.dtOptionsRoles.columns = [
      ...this.columnasRol,
      {
        title: 'Eliminar',
        data: 'Id',
        orderable: false,
        render: (data: any, type: any, full: any) => {
          // Inicializar botones existentes
          let buttons = `
          <button class="ms-CommandButton-button" data-group="rol" data-id="${full.Id}" data-field="${full.NombreRol}" id="btnDelete">
            <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
          </button>
        `;

          return buttons;
        },
      },
    ];

    this.dtTriggerRol.next(this.dtOptionsRoles);

    $('#datatableGrupos').DataTable().destroy();

    this.dtOptionsGrupos.data = this.gruposGrid;
    this.dtOptionsGrupos.columns = [
      ...this.columnasGrupo,
      {
        title: 'Eliminar',
        data: 'Id',
        orderable: false,
        render: (data: any, type: any, full: any) => {
          // Inicializar botones existentes
          let buttons = `
          <button class="ms-CommandButton-button" data-group="grupo" data-id="${full.Id}" data-field="${full.NombreGrupo}" id="btnDelete">
            <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
          </button>
        `;

          return buttons;
        },
      },
    ];

    this.dtTriggerGrupo.next(this.dtOptionsGrupos);
  }

  ngOnChanges() {
    // if (this.idReceived) {
    //   this.usuariosGrid = [];
    //   this.rolesGrid = [];
    //   this.gruposGrid = [];

    //   this.obtenerPermisos();
    // }
    // if (this.idReceivedMenu) {
    //   this.usuariosGrid = [];
    //   this.rolesGrid = [];
    //   this.gruposGrid = [];

    //   this.obtenerPermisos();
    // }

    this.usuariosGrid = [];
    this.rolesGrid = [];
    this.gruposGrid = [];

    this.obtenerPermisos();
  }

  //async ngOnInit(): Promise<void> {
  async ngOnInit() {
    this.usuariosExcluidos = this.usuariosGrid.map((usuario) =>
      parseInt(usuario.Id)
    );
    this.rolesExcluidos = this.rolesGrid.map((rol) => parseInt(rol.Id));
    this.gruposPermitidos = this.gruposGrid.map((grupo) => parseInt(grupo.Id));

    this.paramToken = this.baseService.getParamValue('Token');
    this.paramIdProceso = this.baseService.getParamValue('IdProceso');
    this.idReceived = Number(this.paramIdProceso);      

    this.headers = new HttpHeaders({
      'X-APIKey': AppData.API_KEY,
      Authorization: 'Bearer ' + this.paramToken,
    });

    this.currentUserIdSubscription = this.baseService.currentUserId.subscribe(
      (userId) => {
        
        
        this.idReceived = parseInt(userId);
      }
    );

    this.currentIsOptionMenuSubscription =
      this.baseService.currentIsOptionsMenu.subscribe((isOptionMenu) => {
        this.isOptionMenu = isOptionMenu;
        if (isOptionMenu) {
          if (this.idReceived) {
            this.idReceived = undefined;
          }
        }
      });

    if (this.isOptionMenu) {
      this.currentMenuIdSubscription =
        this.baseService.currentIdOpcionMenu.subscribe((idMenu) => {
          this.idReceivedMenu = parseInt(idMenu);
        });
    }

    console.log(this.idReceived);
    console.log(this.idReceivedMenu);

    var ButtonElements = document.querySelectorAll('.ms-Button');
    for (var i = 0; i < ButtonElements.length; i++) {
      new fabric['Button']();
    }

    if (this.route.snapshot.routeConfig?.path === 'acceso') {
      this.cancelButton = false;
      this.obtenerPermisos();
    }

    let dialog = document.querySelector('.modal-permisos-usuario');
    this.dialogComponentModalPermisosUsuario = new fabric['Dialog'](dialog);
    $('#btnAddPermission').attr('data-group', 'usuario');

    let usersTable = $('#datatableUsuarios').DataTable();
    usersTable.draw();

    /*   this.dtOptButtonsPermisosUsuarios.push({'button-id': 'btnUnCheck', 'button-icon': 'ms-Icon--Checkbox', 'conditional-data': [
      { key: 'field', value: 'Email' }
    ]},
    {'button-id': 'btnCheck', 'button-icon': 'ms-Icon--CheckboxComposite', 'button-hide': true, 'conditional-data': [
      { key: 'field', value: 'Email' }
    ]}); */

    /*    this.dtOptButtonsPermisosRol.push({'button-id': 'btnUnCheck', 'button-icon': 'ms-Icon--Checkbox', 'conditional-data': [
      { key: 'field', value: 'NombreRol' }
    ]},
    {'button-id': 'btnCheck', 'button-icon': 'ms-Icon--CheckboxComposite', 'button-hide': true, 'conditional-data': [
      { key: 'field', value: 'NombreRol' }
    ]}); */

    /*  this.dtOptButtonsPermisosGrupo.push({'button-id': 'btnUnCheck', 'button-icon': 'ms-Icon--Checkbox', 'conditional-data': [
      { key: 'field', value: 'NombreGrupo' }
    ]},
    {'button-id': 'btnCheck', 'button-icon': 'ms-Icon--CheckboxComposite', 'button-hide': true, 'conditional-data': [
      { key: 'field', value: 'NombreGrupo' }
    ]}); */
  }

  ngAfterViewInit(): void {
    //this.reloadPermissions();

    this.elementRef.nativeElement.addEventListener('click', (event) => {
      if (event.target.id === 'btnDelete') {
        this.groupDelete = event.target.getAttribute('data-group');
        this.idDelete = parseInt(event.target.getAttribute('data-id'));
        this.abrirModalDelete();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.currentUserIdSubscription) {
      this.currentUserIdSubscription.unsubscribe();
    }
    if (this.currentMenuIdSubscription) {
      this.currentMenuIdSubscription.unsubscribe();
    }
    if (this.currentIsOptionMenuSubscription) {
      this.currentIsOptionMenuSubscription.unsubscribe();
    }

    this.idReceived = null;
    this.idReceivedMenu = null;
  }

  setDatatableModal(element) {
    switch (element) {
      case 'usuarios':
        let dialog = document.querySelector('.modal-permisos-usuario');
        this.dialogComponentModalPermisosUsuario = new fabric['Dialog'](dialog);

        $('#spanAddPermission').html('Agregar Usuario');
        $('#btnAddPermission').attr('data-group', 'usuario');
        this.serviceUrl = 'Usuario/GetDataTableUsuario';

        break;

      case 'roles':
        // let rolesTable = $('#datatableRoles').DataTable();
        // rolesTable.draw();

        let dialogRol = document.querySelector('.modal-permisos-rol');
        this.dialogComponentModalPermisosRol = new fabric['Dialog'](dialogRol);

        $('#spanAddPermission').html('Agregar Rol');
        $('#btnAddPermission').attr('data-group', 'rol');
        this.serviceUrl = 'RolUsuario/GetDataTableRolUsuario';

        break;

      case 'grupos':
        let groupsTable = $('#datatableGrupos').DataTable();
        groupsTable.draw();

        let dialogGrupo = document.querySelector('.modal-permisos-grupo');
        this.dialogComponentModalPermisosGrupo = new fabric['Dialog'](
          dialogGrupo
        );

        $('#spanAddPermission').html('Agregar Grupo');
        $('#btnAddPermission').attr('data-group', 'grupo');
        this.serviceUrl = 'GrupoUsuario/GetDataTableGrupo';

        break;
    }
  }

  cancelElementRemove()
  {
    
    this.groupDelete=null;
    this.idDelete=null;
  }

  removeElement()
  {
    switch (this.groupDelete) {
      case 'usuario':
        
        this.usuariosPermitidos.splice(
          this.usuariosPermitidos.findIndex((element) => (element = this.idDelete)),
          1
        );

        for (var i = 0; i < this.usuariosGrid.length; i++) {
          if (this.usuariosGrid[i].Id == this.idDelete) {
            this.usuariosGrid.splice(i, 1);
          }
        }

        $('#datatableUsuarios').DataTable().destroy();

        this.dtOptionsUsuarios.data = this.usuariosGrid;

        this.dtTriggerUsuario.next(this.dtOptionsUsuarios);
        break;
      case 'rol':
        this.rolesPermitidos.splice(
          this.rolesPermitidos.findIndex((element) => (element = this.idDelete)),
          1
        );

        for (var i = 0; i < this.rolesGrid.length; i++) {
          if (this.rolesGrid[i].Id == this.idDelete) {
            this.rolesGrid.splice(i, 1);
          }
        }

        $('#datatableRoles').DataTable().destroy();

        this.dtOptionsRoles.data = this.rolesGrid;

        this.dtTriggerRol.next(this.dtOptionsRoles);
        break;
      case 'grupo':
        this.gruposPermitidos.splice(
          this.gruposPermitidos.findIndex((element) => (element = this.idDelete)),
          1
        );

        for (var i = 0; i < this.gruposGrid.length; i++) {
          if (this.gruposGrid[i].Id == this.idDelete) {
            this.gruposGrid.splice(i, 1);
          }
        }

        $('#datatableGrupos').DataTable().destroy();

        this.dtOptionsGrupos.data = this.gruposGrid;

        this.dtTriggerGrupo.next(this.dtOptionsGrupos);
        break;
    }
  }


  abrirDataTableModal() {
    switch ($('#btnAddPermission').attr('data-group')) {
      case 'usuario':
        // var table = $('#datatablePermisosUsuario').DataTable();

        // table.ajax.reload();

        this.usuariosExcluidos = this.usuariosGrid.map((usuario) =>
          parseInt(usuario.Id)
        );

        this.baseService.exportIdsExcluidosUsuarios(this.usuariosExcluidos);

        

        this.dtInstancePermisosUsuarios.ajax.reload(null, false);
        this.dialogComponentModalPermisosUsuario.open();
        
        break;

      case 'rol':
        this.rolesExcluidos = this.rolesGrid.map((rol) => parseInt(rol.Id));
        this.baseService.exportIdsExcluidosRoles(this.rolesExcluidos);
        
        this.dtInstancePermisosRol.ajax.reload(null, false);
        // var table = $('#datatablePermisosRol').DataTable();

        // table.ajax.reload();
        this.dialogComponentModalPermisosRol.open();
        break;

      case 'grupo':
        this.GruposExcluidos = this.gruposGrid.map((grupo) =>
          parseInt(grupo.Id)
        );
        this.baseService.exportIdsExcluidosGrupos(this.GruposExcluidos);
        
        this.dtInstancePermisosGrupo.ajax.reload(null, false);
        // var table = $('#datatablePermisosGrupo').DataTable();

        // table.ajax.reload();
        this.dialogComponentModalPermisosGrupo.open();
        break;
    }
  }

  closeDataTableModal() {
    switch ($('#btnAddPermission').attr('data-group')) {
      case 'usuario':
        this.dialogComponentModalPermisosUsuario.close();
        
        break;

      case 'rol':
        this.dialogComponentModalPermisosRol.close();
        break;

      case 'grupo':
        this.dialogComponentModalPermisosGrupo.close();
        break;
    }
  }

  gridLoaded(event: any) {
    this.dtTableId = event['tableId'];
    
    if (event['tableId'] == 'datatablePermisosUsuario' && event['table']) {
      
      this.dtInstancePermisosUsuarios = event['table'];
      this.dtOptionsPermisosUsuario = event['options'];
    }

    if (event['tableId'] == 'datatablePermisosRol' && event['table']) {
      this.dtInstancePermisosRol = event['table'];
      this.dtOptionsPermisosRol = event['options'];
    }

    if (event['tableId'] == 'datatablePermisosGrupo' && event['table']) {
      this.dtInstancePermisosGrupo = event['table'];
      this.dtOptionsPermisosGrupo = event['options'];
    }
  }

  customClick(event: any) {
    try {
      const campo = event['data-field'];
      const id = parseInt(event['data-id']);
      this.dtTableId = event['table-id'];

      switch (this.dtTableId) {
        case 'datatablePermisosUsuario':
          if (event['button-id'] == 'btnCheck') {
            
            this.usuariosPermitidos.splice(
              this.usuariosPermitidos.findIndex((element) => (element = id)),
              1
            );

            for (var i = 0; i < this.usuariosGrid.length; i++) {
              if (this.usuariosGrid[i].Id == id) {
                this.usuariosGrid.splice(i, 1);
              }
            }

            event.event.srcElement.parentNode.children[
              'btnUnCheck'
            ].setAttribute('style', 'display:block');
            event.event.srcElement.parentNode.children['btnCheck'].setAttribute(
              'style',
              'display:none'
            );

            $('#datatableUsuarios').DataTable().destroy();

            this.dtOptionsUsuarios.data = this.usuariosGrid;
            this.dtOptionsUsuarios.columns = [
              ...this.columnasUsuario,
              {
                title: 'Eliminar',
                data: 'Id',
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                      <button class="ms-CommandButton-button" data-group="usuario" data-id="${full.Id}" data-field="${full.Email}" id="btnDelete">
                        <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                      </button>
                      `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerUsuario.next(this.dtOptionsUsuarios);

            //this.dtOptionsUsuarios.data = this.usuariosGrid;
            //this.dataTable.reloadTable("datatableUsuarios", this.dtOptionsUsuarios);
          } else if (event['button-id'] == 'btnUnCheck') {
            let idUserFound = false;

            for (var i = 0; i < this.usuariosPermitidos.length; i++) {
              if (this.usuariosPermitidos[i] == id) {
                idUserFound = true;
              }
            }

            if (!idUserFound) {
              this.usuariosPermitidos.push(id);
            }

            let userFound = false;

            for (var i = 0; i < this.usuariosGrid.length; i++) {
              if (this.usuariosGrid[i].Id == id) {
                userFound = true;
              }
            }

            if (!userFound) {
              this.usuariosGrid.push({ Email: campo, Id: id });
            }

            event.event.srcElement.parentNode.children[
              'btnUnCheck'
            ].setAttribute('style', 'display:none');
            event.event.srcElement.parentNode.children['btnCheck'].setAttribute(
              'style',
              'display:block'
            );

            $('#datatableUsuarios').DataTable().destroy();

            this.dtOptionsUsuarios.data = this.usuariosGrid;
            this.dtOptionsUsuarios.columns = [
              ...this.columnasUsuario,
              {
                title: 'Eliminar',
                data: 'Id',
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                    <button class="ms-CommandButton-button" data-group="usuario" data-id="${full.Id}" data-field="${full.Email}" id="btnDelete">
                      <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                    </button>
                    `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerUsuario.next(this.dtOptionsUsuarios);
          }

          break;

        case 'datatablePermisosRol':
          if (event['button-id'] == 'btnCheck') {
            this.rolesPermitidos.splice(
              this.rolesPermitidos.findIndex((element) => (element = id)),
              1
            );

            for (var i = 0; i < this.rolesGrid.length; i++) {
              if (this.rolesGrid[i].Id == id) {
                this.rolesGrid.splice(i, 1);
              }
            }

            event.event.srcElement.parentNode.children[
              'btnUnCheck'
            ].setAttribute('style', 'display:block');
            event.event.srcElement.parentNode.children['btnCheck'].setAttribute(
              'style',
              'display:none'
            );

            $('#datatableRoles').DataTable().destroy();

            this.dtOptionsRoles.data = this.rolesGrid;
            this.dtOptionsRoles.columns = [
              ...this.columnasRol,
              {
                title: 'Eliminar',
                data: 'Id',
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                      <button class="ms-CommandButton-button" data-group="rol" data-id="${full.Id}" data-field="${full.NombreRol}" id="btnDelete">
                        <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                      </button>
                      `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerRol.next(this.dtOptionsRoles);
            // this.dtOptionsRoles.data = this.rolesGrid;
            // this.dataTable.reloadTable("datatableRoles", this.dtOptionsRoles);
          } else if (event['button-id'] == 'btnUnCheck') {
            let idRoleFound = false;

            for (var i = 0; i < this.rolesPermitidos.length; i++) {
              if (this.rolesPermitidos[i] == id) {
                idRoleFound = true;
              }
            }

            if (!idRoleFound) {
              this.rolesPermitidos.push(id);
            }

            let roleFound = false;

            for (var i = 0; i < this.rolesGrid.length; i++) {
              if (this.rolesGrid[i].Id == id) {
                roleFound = true;
              }
            }

            if (!roleFound) {
              this.rolesGrid.push({ NombreRol: campo, Id: id });
            }

            event.event.srcElement.parentNode.children[
              'btnUnCheck'
            ].setAttribute('style', 'display:none');
            event.event.srcElement.parentNode.children['btnCheck'].setAttribute(
              'style',
              'display:block'
            );

            $('#datatableRoles').DataTable().destroy();

            this.dtOptionsRoles.data = this.rolesGrid;
            this.dtOptionsRoles.columns = [
              ...this.columnasRol,
              {
                title: 'Eliminar',
                data: 'Id',
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                      <button class="ms-CommandButton-button" data-group="rol" data-id="${full.Id}" data-field="${full.NombreRol}" id="btnDelete">
                        <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                      </button>
                      `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerRol.next(this.dtOptionsRoles);
          }

          break;
        case 'datatablePermisosGrupo':
          if (event['button-id'] == 'btnCheck') {
            this.gruposPermitidos.splice(
              this.gruposPermitidos.findIndex((element) => (element = id)),
              1
            );

            for (var i = 0; i < this.gruposGrid.length; i++) {
              if (this.gruposGrid[i].Id == id) {
                this.gruposGrid.splice(i, 1);
              }
            }

            event.event.srcElement.parentNode.children[
              'btnUnCheck'
            ].setAttribute('style', 'display:block');
            event.event.srcElement.parentNode.children['btnCheck'].setAttribute(
              'style',
              'display:none'
            );

            $('#datatableGrupos').DataTable().destroy();

            this.dtOptionsGrupos.data = this.gruposGrid;
            this.dtOptionsGrupos.columns = [
              ...this.columnasGrupo,
              {
                title: 'Eliminar',
                data: 'Id',
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                      <button class="ms-CommandButton-button" data-group="grupo" data-id="${full.Id}" data-field="${full.NombreGrupo}" id="btnDelete">
                        <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                      </button>
                      `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerGrupo.next(this.dtOptionsGrupos);
          } else if (event['button-id'] == 'btnUnCheck') {
            let idGroupFound = false;

            for (var i = 0; i < this.gruposPermitidos.length; i++) {
              if (this.gruposPermitidos[i] == id) {
                idGroupFound = true;
              }
            }

            if (!idGroupFound) {
              this.gruposPermitidos.push(id);
            }

            let groupFound = false;

            for (var i = 0; i < this.gruposGrid.length; i++) {
              if (this.gruposGrid[i].Id == id) {
                groupFound = true;
              }
            }

            if (!groupFound) {
              this.gruposGrid.push({ NombreGrupo: campo, Id: id });
            }

            event.event.srcElement.parentNode.children[
              'btnUnCheck'
            ].setAttribute('style', 'display:none');
            event.event.srcElement.parentNode.children['btnCheck'].setAttribute(
              'style',
              'display:block'
            );

            $('#datatableGrupos').DataTable().destroy();

            this.dtOptionsGrupos.data = this.gruposGrid;
            this.dtOptionsGrupos.columns = [
              ...this.columnasGrupo,
              {
                title: 'Eliminar',
                data: 'Id',
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                      <button class="ms-CommandButton-button" data-group="grupo" data-id="${full.Id}" data-field="${full.NombreGrupo}" id="btnDelete">
                        <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                      </button>
                      `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerGrupo.next(this.dtOptionsGrupos);
          }

          break;
      }
    } catch (error) {
      console.error('Error al retornar evento datatable', error);
    }
  }

  async enviarPermisosProceso() {
    const idsUsuarios =
      this.usuariosGrid.length > 0
        ? this.usuariosGrid.map((item) => item.Id).join(';') + ';'
        : '';
    const idsGrupos =
      this.gruposGrid.length > 0
        ? this.gruposGrid.map((item) => item.Id).join(';') + ';'
        : '';
    const idsRoles =
      this.rolesGrid.length > 0
        ? this.rolesGrid.map((item) => item.Id).join(';') + ';'
        : '';

    if (this.ActivityId) {
      this.permisosProcesoObj.IdProceso = this.idReceived;
      this.permisosProcesoObj.IdTarea = this.ActivityId;
    } else {
      this.permisosProcesoObj.Id = this.idReceived;
    }
    this.permisosProcesoObj.GruposPermitidos = idsGrupos;
    this.permisosProcesoObj.UsuariosPermitidos = idsUsuarios;
    this.permisosProcesoObj.RolesPermitidos = idsRoles;

    try {
      this.botonProcesando = true;
      const response = await lastValueFrom(
        this.http.post<any>(
          AppData.API_URL +
            (!this.ActivityId
              ? 'Proceso/ActualizarPermisosProceso'
              : 'Proceso/ActualizarPermisosTarea'),
          this.permisosProcesoObj,
          { headers: this.headers }
        )
      );

      if (!response.Ok) {
        this.dialogComponentGuardarPermisos.close();

        let mensajeError = '<ul>';
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += '</ul>';

        this.baseService.triggerShowModal(
          'Error al actualizar permisos',
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.abrirModalPermisosGuardados();
        this.dialogComponentGuardarPermisos.close();
        this.botonProcesando = false;
      }
    } catch (error: any) {
      this.botonProcesando = false;
    }

    console.log(this.permisosProcesoObj);
  }
  async enviarPermisosMenu() {
    const idsUsuarios =
      this.usuariosGrid.length > 0
        ? this.usuariosGrid.map((item) => item.Id).join(';') + ';'
        : '';
    const idsGrupos =
      this.gruposGrid.length > 0
        ? this.gruposGrid.map((item) => item.Id).join(';') + ';'
        : '';
    const idsRoles =
      this.rolesGrid.length > 0
        ? this.rolesGrid.map((item) => item.Id).join(';') + ';'
        : '';

    this.permisosProcesoObj.IdMenu = this.idReceivedMenu;
    this.permisosProcesoObj.GruposPermitidos = idsGrupos;
    this.permisosProcesoObj.UsuariosPermitidos = idsUsuarios;
    this.permisosProcesoObj.RolesPermitidos = idsRoles;

    try {
      this.botonProcesando = true;
      const response = await this.baseService.create(
        'MenuAcceso/ActualizarMenuAcceso',
        this.permisosProcesoObj
      );

      if (!response.Ok) {
        this.dialogComponentGuardarPermisos.close();

        let mensajeError = '<ul>';
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += '</ul>';

        this.baseService.triggerShowModal(
          'Error al actualizar permisos',
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.abrirModalPermisosGuardados();
        this.dialogComponentGuardarPermisos.close();
        this.botonProcesando = false;
      }
    } catch (error: any) {
      this.botonProcesando = false;
    }

    console.log(this.permisosProcesoObj);
  }

  async obtenerPermisos() {
    try {
      let responseList = null;
      this.botonProcesando = true;
      
      if (this.ActivityId) {
        this.permisosProcesoObj.IdProceso = this.idReceived;
        this.permisosProcesoObj.IdTarea = this.ActivityId;

        responseList = await lastValueFrom(
          this.http.post<any>(
            AppData.API_URL + 'Proceso/ListPermisosTarea',
            this.permisosProcesoObj,
            { headers: this.headers }
          )
        );
      }
      if (this.idReceivedMenu) {
        console.log(this.idReceivedMenu);

        responseList = await lastValueFrom(
          this.http.get<any>(
            AppData.API_URL +
              `MenuAcceso/ListPermisosMenu?IdMenu=${this.idReceivedMenu}`,
            { headers: this.headers }
          )
        );
      }
      if (this.idReceived) {
        responseList = await lastValueFrom(
          this.http.get<any>(
            AppData.API_URL +
              'Proceso/ListPermisosProceso?id=' +
              this.idReceived,
            { headers: this.headers }
          )
        );
      }
      if (this.isOptionMenu) {
        if (responseList.Ok) {
          this.usuariosGrid = responseList.Data.ListaUsuarios;
          this.rolesGrid = responseList.Data.ListaRoles;
          this.gruposGrid = responseList.Data.ListaGrupos;

          this.botonProcesando = false;
        } else {
          this.botonProcesando = false;
        }
      } else {
        if (responseList.Ok) {
          this.usuariosGrid = responseList.Data.ListaUsuarios;
          this.rolesGrid = responseList.Data.ListaRoles;
          this.gruposGrid = responseList.Data.ListaGrupos;

          this.usuariosPermitidos = responseList.Data.ListaUsuarios.map(
            (user) => parseInt(user.Id)
          );

          this.rolesPermitidos = responseList.Data.ListaRoles.map((rol) =>
            parseInt(rol.Id)
          );

          this.gruposPermitidos = responseList.Data.ListaGrupos.map((grupo) =>
            parseInt(grupo.Id)
          );

          this.botonProcesando = false;
        } else {
          this.botonProcesando = false;
        }
      }

      this.reloadPermissions();
    } catch (error: any) {
      this.botonProcesando = false;
    }
  }

  abrirModalDelete() {
    const dialog = document.querySelector('.eliminar-permisos');
    this.dialogComponentRemovePermision = new fabric['Dialog'](dialog);
    this.dialogComponentRemovePermision.open();
  }

  abrirModalPermisos() {
    const dialog = document.querySelector('.guardar-permisos');
    this.dialogComponentGuardarPermisos = new fabric['Dialog'](dialog);
    this.dialogComponentGuardarPermisos.open();
  }

  abrirModalPermisosGuardados() {
    const dialogPermisosGuardados = document.querySelector(
      '.datatable-procesos'
    );
    this.dialogComponentPermisosGuardados = new fabric['Dialog'](
      dialogPermisosGuardados
    );
    this.dialogComponentPermisosGuardados.open();
  }
  abrirDatatableProcesos() {
    if (!this.cancelButton) {
      this.router.navigate(['home/procesos']);
    } else {
      const dialogPermisosGuardados = document.querySelector(
        '.datatable-procesos'
      );
      this.dialogComponentPermisosGuardados = new fabric['Dialog'](
        dialogPermisosGuardados
      );
      this.dialogComponentPermisosGuardados.close();
    }
  }
  abrirDatatablePermisosMenu() {
    this.router.navigate(['home/permisos-menu']);
  }
}

export class SetPermisos {
  Id?: number;
  IdProceso?: number;
  IdTarea?: string;
  IdMenu?: number;
  UsuariosPermitidos: string;
  RolesPermitidos: string;
  GruposPermitidos: string;

  constructor() {
    this.Id = undefined;
    this.IdProceso = undefined;
    this.IdTarea = undefined;
    this.IdMenu = undefined;
    this.UsuariosPermitidos = undefined;
    this.RolesPermitidos = undefined;
    this.GruposPermitidos = undefined;
  }
}
